import React from 'react';
import {Title, Image,  Slideshow} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle09 = () => (<div>

  <Title>Die Rollstühle im Rennen</Title>

  <Slideshow>
    <section>
      <Image
        source={require('./09_1_WHEEL_Team_RT-Movers_AlessandroDellaBella_102.jpg')}
        title='Rollstuhl - Der Schnelle'
        caption={
          <span>
            <b>Der Schnelle</b>
            Weil seine vier Räder alle einzeln angetrieben sind, erreicht dieser
            Rollstuhl hohe Geschwindigkeiten und kann Treppen hochklettern.
            Flexible Vorder- und Hinterachsen sorgen für ein problemloses
            Vorwärtskommen in wackeligem Terrain.
          <br/>
            Team RT Movers, Universität Wakayama, Japan
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_2_WHEEL_Team-HSR-Enhanced_AlessandroDellaBella_040.jpg')}
        title='Rollstuhl - Der Rotierende'
        caption={
          <span>
            <b>Der Rotierende</b>
            Rotierende Metallstifte heben den Rollstuhl Stufe um Stufe empor. Das
            Gewicht des Fahrers wird nach vorne verlagert, damit der Rollstuhl nicht
            nach hinten wegkippt. Dank vier einzeln steuerbaren Rädern ist das Gefährt 
            wendig und schnell.
            <br/>
            Team HSR Enhanced, Hochschule Rapperswil, Schweiz 
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_3_WHEEL_Team-laddroller_AlessandroDellaBella_039.jpg')}
        title='Rollstuhl - Der Wendige'
        caption={
          <span>
            <b>Der Wendige</b>
            Dieses Gefährt ist eine Kombination aus Exoskelett und Rollstuhl. Es
            kann die Position des Piloten von Sitzen bis Stehen variieren. Seine
            Hinterräder können vorwärts, rückwärts und seitwärts drehen und sorgen
            so für eine hohe Beweglichkeit.
            <br/>
            Team Laddroller, Griechenland
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_4_WHEEL_Team_Avalanche_AlessandroDellaBella_104.jpg')}
        title='Rollstuhl - Der Variable'
        caption={
          <span>
            <b>Der Variable</b>
            Dieser Rollstuhl kann seitwärts fahren oder um die eigene Achse drehen.
            Wenn das Gelände für Räder unbefahrbar wird, senkt er einen speziellen
            Raupenantrieb zu Boden. So kann er auch Treppen hochsteigen.
            <br/>
            Team Avalanche, Universität Ljubljana, Slowenien
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_5_WHEEL_Team-HKUST-wheels_AlessandroDellaBella_036.jpg')}
        title='Rollstuhl - Das Raupenfahrzeug'
        caption={
          <span>
            <b>Das Raupenfahrzeug</b>
            Mit seinen zwei Raupen ist der Rollstuhl so geländegängig wie ein Panzer.
            Kleinere Hindernisse überfährt er problemlos. Treppen fährt er dank
            der Raupen hoch, als wären sie eine Rampe.
            <br/>
            Team HKUST, Hong Kong University of Science and Technology, Hong Kong
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_6_WHEEL_Team-HERL-wheels_AlessandroDellaBella_042.jpg')}
        title='Rollstuhl - Der Rollstuhl mit Stelzen'
        caption={
            <span>
            <b>Der Rollstuhl mit Stelzen</b>
            Der MeBot hat drei Radpaare. Will er ein Hindernis überwinden, fährt er
            das erste Radpaar aus und hebt das Fahrzeug an. Dann rücken die mittleren
            Räder nach und hieven den Rollstuhl so über das Hindernis. Zuletzt wird
            das letzte Radpaar nachgezogen.
            <br/>
            HERL MeBot, Human Engineering Research Lab, Pittsburgh, USA
            <br/> 
            Fotos: ETHZ
          </span>
        }
      />
    </section>

  </Slideshow>

  <Particle
    number={2}
  />

  <Particle
    number={3}
  />

</div>);

export default Particle09;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle09/Particle09.js
 **/